import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function PropertyImageHandler({ property }) {

    const [mainImage, setMainImage] = useState(property.images[0]);
    const [images, setImages] = useState(property.images.slice(1, 5));
    const navigate = useNavigate();

    useEffect(() => {
        setMainImage(property.images[0]); 
        setImages(property.images.slice(1, 5)); 
    }, [property.images]); 

    const handleImageChange = (clickedImage) => {
        const clickedIndex = images.indexOf(clickedImage);
        const newMainImage = clickedImage;
        const newImages = [...images];
        newImages[clickedIndex] = mainImage;

        setMainImage(newMainImage);
        setImages(newImages);
    };


    // Handle cardClick
    const handleCardClick = ()=>{
        navigate(`/properties/property/${property._id}`);

    }

    return (
        <div className="imageContainer" onClick={handleCardClick}>
            <div 
                className="mainImage" 
                style={{ 
                    backgroundImage: `url(${process.env.REACT_APP_BACKEND}/${mainImage.replace('public/', '')})`, 
                    width: `${images.length === 0 ? '100%': '70%'}`
                }}
            ></div>

            <div className="imageSlides" style={{      width: `${images.length !== 0 ? '30%': '0%'}`}}>
                {images.map((img, index) => (
                    <span 
                        key={index} 
                        className={`image${index + 1}`} 
                        style={{ 
                            backgroundImage: `url(${process.env.REACT_APP_BACKEND}/${img.replace('public/', '')})` 
                        }}
                        onClick={() => handleImageChange(img)}
                    ></span>
                ))}
            </div>
        </div>
    );
};
